
import React, { FC, useState } from "react";
//components
import RadionPackaging from "../radionPackaging";
import { BionexoAnserewedFields, BionexoAnserewedLabel, BionexoAnserewedLine, ObsFieldIcon } from "./styles";
//assets
import emptyObsIcon from "img/ObsIcon.svg";
import savedObsIcon from "img/ObsIconSaved.svg";
//utils
import { DisableButton } from "utils/DisableButton";


interface IAnsweredBionexo {
	item: any;
	notes: string;
	isEditing: any;
	radionPackaging: any;
	quantityPackaging: any;
	isOrderStatus: boolean;
	setRadionPackaging: any;
	setOpenItemObsModal: any;
	setQuantityPackaging: any;
	isKitPackagingActive: any;
	setIsKitPackagingActive: any;
	formatedSubUnidValue: string;
  unitPrice?: string;
}
export const AnsweredBionexo: FC<IAnsweredBionexo> = ({
	item,
	notes,
	isEditing,
	isOrderStatus,
	radionPackaging,
	quantityPackaging,
	setRadionPackaging,
	setOpenItemObsModal,
	isKitPackagingActive,
	formatedSubUnidValue,
	setQuantityPackaging,
	setIsKitPackagingActive,
  unitPrice
}) => (
	<>
		<BionexoAnserewedLine budgetSaved={!isEditing}>
			<BionexoAnserewedFields>
				<div className="totalSubUnit">
					<span className="subtitle">Valor Unit.</span>
					<div className="value">
						{isEditing ? formatedSubUnidValue : unitPrice}
					</div>
				</div>

				<div className="QItemRaioPackagigng">
					<RadionPackaging
						isEditing={isEditing}
						ItemMultiplo={item.multiple}
						isOrderStatus={isOrderStatus}
						radionPackaging={radionPackaging}
						sequenceNumber={item.sequenceNumber}
						setRadionPackaging={setRadionPackaging}
						sequenceBudget={item.budgets?.sequence}
						setQuantityPackaging={setQuantityPackaging}
						conversionFactorValue={item.conversionFactor}
						setIsKitPackagingActive={setIsKitPackagingActive}
					/>
				</div>
				<div className="quantityPackaging">
					<span className="subtitle">Qtd. Embalagem</span>
					<div className="value">
						{quantityPackaging ? quantityPackaging : "-"}
						{isKitPackagingActive && quantityPackaging ? "*" : ""}
					</div>
				</div>

				<ObsFieldIcon>
					<span className="subtitle">Obs.</span>
					<div
						onClick={() => !isOrderStatus && (isEditing ? setOpenItemObsModal(true) : setOpenItemObsModal(false))}
					>
						{notes ? (
							<img src={savedObsIcon} className={`emptyObsFieldIcon ${DisableButton(isOrderStatus)}`} />
						) : (
							<img src={emptyObsIcon} className={`savedObsFieldIcon ${DisableButton(isOrderStatus)}`} />
						)}
					</div>
				</ObsFieldIcon>
			</BionexoAnserewedFields>
		</BionexoAnserewedLine>

		<BionexoAnserewedLabel>
			<span>CAMPOS RESPONDIDOS NA COTAÇÃO DA BIONEXO</span>
		</BionexoAnserewedLabel>
	</>
);
